import { render, staticRenderFns } from "./WelcomeToPigeon.vue?vue&type=template&id=6438a701&scoped=true&"
import script from "./WelcomeToPigeon.vue?vue&type=script&lang=ts&"
export * from "./WelcomeToPigeon.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeToPigeon.vue?vue&type=style&index=0&id=6438a701&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6438a701",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
